
  // Renders the wellness score cards into the section. Pure render — receives
  // the questions array and draws the charts.
  function renderSectionScores(questions) {
    const stats = calcStats(questions);
    console.log("stats in scores: ", stats);

    const container = document.querySelector('.scoresContainer-section .swiper-wrapper');

    if (container) {
      // clear loader
      container.innerHTML = '';

      stats.forEach((stat, index) => {
        const chartId = `chart-${index}`;
        const box = document.createElement('div');
        box.className = 'swiper-slide'; // each slide
        box.innerHTML = `
          <div class="scoreBox" style="position: relative;">
            <div class="scorebox-inner">
              <div style="width: 150px; height: 150px; margin: auto; position: relative;">
                <canvas id="${chartId}" width="150" height="150"></canvas>
              </div>
              <h2>${stat.title}</h2>
              <p>${stat.text}</p>
            </div>
          </div>
        `;
        container.appendChild(box);

        // colors for each stat type
        // ✅ function to get color based on percentage
        function getColorByValue(value) {
          if (value <= 40) return '#FF8251';   // red
          if (value <= 69) return '#FFC800';   // orange
          return '#00BD03';                    // green
        }


        const ctx = document.getElementById(chartId).getContext('2d');
        new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [stat.points, 100 - stat.points],
              backgroundColor: [getColorByValue(stat.points), '#E5E5E5'],
              borderWidth: 0
            }]
          },
          options: {
            cutout: '95%',
            responsive: false,
            plugins: {
              legend: { display: false },
              tooltip: { enabled: false }
            }
          },
          plugins: [{
            id: 'centerText',
            beforeDraw: (chart) => {
              const { width, height, ctx } = chart;
              ctx.restore();

              const text = `${stat.points}`;
              const subText = '%';
              ctx.fillStyle = '#000';

              const fontSize = (height / 4).toFixed(2);
              ctx.font = `${fontSize}px sans-serif`;
              const textWidth = ctx.measureText(text).width;

              const subFontSize = (height / 12).toFixed(2);
              ctx.font = `${fontSize}px sans-serif`;
              const totalWidth = textWidth + ctx.measureText(subText).width * (subFontSize / fontSize);

              const textX = Math.round((width - totalWidth) / 2);
              const textY = height / 2;

              ctx.textBaseline = 'middle';
              ctx.font = `${fontSize}px sans-serif`;
              ctx.fillText(text, textX, textY);

              ctx.font = `${subFontSize}px sans-serif`;
              ctx.fillText(subText, textX + textWidth + 2, textY + 7);

              ctx.save();
            }
          }]
        });
      });

      // ✅ init Swiper AFTER slides are created
      let swiper;

      function initSwiper() {
        if (window.innerWidth < 768) {
          if (!swiper) { // only init if not already initialized
            swiper = new Swiper('.scoresContainer-section', {
              slidesPerView: 1,
              loop: false,
              pagination: {
                el: '.scores-pagination',
                clickable: true,
              },
            });
          }
        } else {
          if (swiper) { // destroy if window wider than 768
            swiper.destroy(true, true);
            swiper = undefined;
          }
        }
      }

      // run on load
      initSwiper();

      // run on resize
      window.addEventListener('resize', () => {
        initSwiper();
      });

    }
  }

  // Fallback path: original authenticated API → localStorage. Used only when the
  // quizResultDataReady event doesn't carry questions (e.g. some logged-in flows).
  function initSectionScoresFromApi() {
    fetchQuestionnaire(primaryUrl, fallbackUrl, payload, headers)
      .then(data => {
        console.log('✅ API Response in scores and nutritions:', data);

        let latest = null;
        let questions = [];

        if (Array.isArray(data) && data.length > 0) {
          latest = data.reduce((a, b) => (a.id > b.id ? a : b));
          questions = latest?.results?.questions || [];
        } else {
          console.warn('⚠️ No valid questionnaire data found.');
        }

        // Fallback: no questions from the API (e.g. recovery on a fresh device) →
        // use the answers stored in localStorage (helper defined in scores.js).
        if (!questions.length) {
          console.warn('⚠️ No questions from API → falling back to localStorage');
          questions = getQuestionsFromLocalStorage();
        }

        renderSectionScores(questions);
      })
      .catch(error => {
        console.error('❌ Failed to load questions:', error.message);
        const questions = getQuestionsFromLocalStorage();
        if (questions.length) renderSectionScores(questions);
      });
  }

  // Primary path: render from the data load-results.js hands out via the
  // quizResultDataReady event. This carries currentQuestionnaire.questions for
  // every flow (logged-in, local quiz, and recovery) and fires AFTER recovery
  // has populated everything — so it avoids the race with the recovery
  // localStorage write and the unauthenticated API call.
  function handleScoresData(data) {
    const questions =
      data?.currentQuestionnaire?.questions ||
      data?.currentQuestionnaire?.results?.questions ||
      [];

    if (questions.length) {
      renderSectionScores(questions);
    } else {
      // Event didn't carry questions → fall back to the API / localStorage path.
      initSectionScoresFromApi();
    }
  }

  if (window.quizResultData) {
    handleScoresData(window.quizResultData);
  } else {
    window.addEventListener(
      'quizResultDataReady',
      function (e) {
        handleScoresData(e.detail);
      },
      { once: true }
    );
  }
